"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeltaArrowNumber = exports.DeltaArrow = void 0;
var React = __importStar(require("react"));
var rankingUtil_1 = require("./rankingUtil");
exports.DeltaArrow = function (_a) {
    var delta = _a.delta;
    if (delta === 0) {
        return null;
    }
    else {
        if (delta > 0) {
            return React.createElement("i", { className: "fa fa-arrow-up" });
        }
        else {
            return React.createElement("i", { className: "fa fa-arrow-down" });
        }
    }
};
exports.DeltaArrowNumber = function (props) {
    var delta = rankingUtil_1.getDelta(props.ranks, props.latestYear);
    if (delta === 0) {
        return React.createElement("span", null, "-");
    }
    else {
        if (delta > 0) {
            return React.createElement("span", null,
                React.createElement("i", { className: "fa fa-arrow-up" }),
                " ",
                delta);
        }
        else {
            return React.createElement("span", null,
                React.createElement("i", { className: "fa fa-arrow-down" }),
                " ",
                delta);
        }
    }
};
